import { Box, Typography } from "@mui/material";
import ParseHTML from "./ParseHTML";

//This function creates a boilerplate for member and customer care.
export default function MemberCustomerCareBoilerPlate() {

    const message = process.env.REACT_APP_MCC_INFO!;

    return (
        <Box padding={2}>
            <Typography variant="h6" color="secondary.dark" paragraph={true}>{ParseHTML(message)}</Typography>
        </Box>
    );
}